export default "__VITE_ASSET__DcTAkM9k__"